export default __webpack_public_path__ + "static/media/twitter1.666e192a.svg";